export interface User {
  uid?: string;
  role?: string; //administrator / moderator / freelancer / owner / employee / customer
  displayName?: string;
  email: string;
  photoURL?: string;
  password?: string;
  disabled?: boolean;

  isPremium?: boolean;
  expirationOn?: Date;
  admin?: boolean;
  moderator?: boolean;
  product?: boolean;
  customer?: boolean;
  warehouse?: boolean;
  finance?: boolean;
  receipt?: boolean;
  purchase?: boolean;
  loan?: boolean;
  working?: boolean;
  salesman?: boolean;
  companyId?: string;
  shopId?: string;
  printReceiptA4?: boolean;
  printReceiptPos?: boolean;
  language?: string;
  shopName?: string;
  webUrl?: string;
  offlineDb?: boolean;
}

export class UserData {
  shopId?: string;
  uid?: string;
  email: string;
  role?: string;
  displayName?: string;
  photoURL?: string;

  coins?: number;
  stars?: number;
  hearts?: number;
  noLiked?: number;

  noProduct?: number;
  noUser?: number;
  noCustomer?: number;
  amount?: number;
  notifications?: number;

  createdOn?: Date;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}
